(function(){
    angular
        .module('app')
        .directive('stringToInt', stringToInt);

        stringToInt.$inject = ['$timeout'];
        function stringToInt($timeout){
            return {
	            require: 'ngModel',
	            link: function(scope, element, attrs, ngModel) {
			      ngModel.$parsers.push(function(value) {
			      	console.log(value+'a');
			      	if(typeof(value)!='undefined' && value!=''){
			        	return '' + value;
			        }
			      });
			      ngModel.$formatters.push(function(value) {
			      	if(typeof(value)!='undefined' && !isNaN(value) && value!=''){
			      		//console.log(value);
			      		//console.log("AS");
				        return ''+parseInt(value);
				    }
			      });
				}
        	}
        }
})();